import {Button} from '@primer/react'
import {Dialog} from '@primer/react/deprecated'
import {Dialog as Dialog2} from '@primer/react/experimental'

import styles from './DangerConfirmationDialog.module.css'
import {isFeatureEnabled} from '@github-ui/feature-flags'

export function DangerConfirmationDialog({
  isOpen,
  title,
  text,
  buttonText,
  onDismiss,
  onConfirm,
}: {
  isOpen: boolean
  title: string
  text: string
  buttonText: string
  onDismiss: () => void
  onConfirm: () => void
}) {
  const rulesetDeletionConfirmation = isFeatureEnabled('ruleset_deletion_confirmation')
  if (rulesetDeletionConfirmation) {
    return (
      <DangerConfirmationDialog2
        isOpen={isOpen}
        title={title}
        text={text}
        buttonText={buttonText}
        onDismiss={onDismiss}
        onConfirm={onConfirm}
      />
    )
  } else {
    return (
      <DangerConfirmationDialog1
        isOpen={isOpen}
        title={title}
        text={text}
        buttonText={buttonText}
        onDismiss={onDismiss}
        onConfirm={onConfirm}
      />
    )
  }
}

function DangerConfirmationDialog1({
  isOpen,
  title,
  text,
  buttonText,
  onDismiss,
  onConfirm,
}: {
  isOpen: boolean
  title: string
  text: string
  buttonText: string
  onDismiss: () => void
  onConfirm: () => void
}) {
  return (
    <Dialog isOpen={isOpen} onDismiss={onDismiss}>
      <Dialog.Header>{title}</Dialog.Header>
      <div className={styles.DangerDialogContent}>
        <span>{text}</span>
        <div className={styles.DangerDialogButtonContainer}>
          <Button type="button" onClick={onDismiss}>
            Cancel
          </Button>
          <Button type="button" variant="danger" onClick={onConfirm} className={styles.DangerDialogConfirmButton}>
            {buttonText}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}

function DangerConfirmationDialog2({
  isOpen,
  title,
  text,
  buttonText,
  onDismiss,
  onConfirm,
}: {
  isOpen: boolean
  title: string
  text: string
  buttonText: string
  onDismiss: () => void
  onConfirm: () => void
}) {
  return (
    isOpen && (
      <Dialog2
        title={title}
        onClose={onDismiss}
        footerButtons={[
          {buttonType: 'default', content: 'Cancel', onClick: onDismiss},
          {buttonType: 'danger', content: buttonText, onClick: onConfirm},
        ]}
      >
        {text}
      </Dialog2>
    )
  )
}
